
export type LocalEvent = {
  _id: string,
  lat: number,
  lng: number
}

// Update this when you update the map pins, or they won't show up!
export const ACX_EVENTS_LAST_UPDATED = new Date('2023-08-28T23:09:49.077Z');

// these need to be updated for each ACX meetup
export const localEvents = [
  {
    "_id": "bjWcYLHAd6ygtjxFu",
    "lat": 9.0690546,
    "lng": 7.4784446
  },
  {
    "_id": "ddJqT9EGTyRLnDnr9",
    "lat": -33.92817,
    "lng": 18.42267
  },
  {
    "_id": "diMyfEtEMj5Y4QBQa",
    "lat": 0.279938,
    "lng": 32.820062
  },
  {
    "_id": "2mD4LrLpCmtBTFcjm",
    "lat": -35.2729725,
    "lng": 149.1324762
  },
  {
    "_id": "3NkCrLCQrJzdHMZNo",
    "lat": -28.1421292,
    "lng": 153.4954627
  },
  {
    "_id": "Ybtvo2b4MPJDnamKy",
    "lat": -37.8047158,
    "lng": 144.9630204
  },
  {
    "_id": "xZQCD3Ro7KNFG939P",
    "lat": -33.87675979999999,
    "lng": 151.2058953
  },
  {
    "_id": "HtSnjqgPR5g7Cdzta",
    "lat": 22.2811864,
    "lng": 114.1578201
  },
  {
    "_id": "woeNyyA2MwCocQtff",
    "lat": 12.9742758,
    "lng": 77.60702409999999
  },
  {
    "_id": "Yj9MHguuKHaznp4bo",
    "lat": 19.1265134,
    "lng": 72.8204695
  },
  {
    "_id": "bc73wm65vCwGk5kzG",
    "lat": -6.2362408,
    "lng": 106.7932795
  },
  {
    "_id": "AbCq4nMfBMymECvGZ",
    "lat": 33.3259368,
    "lng": 44.4600348
  },
  {
    "_id": "5KzapBcA3AffA8H3o",
    "lat": 32.0716535,
    "lng": 34.7868695
  },
  {
    "_id": "eKzfkv4CkLEKLJ8aa",
    "lat": 35.6444362,
    "lng": 139.7011943
  },
  {
    "_id": "vKYS674jtqMnDtA52",
    "lat": 3.114569,
    "lng": 101.6403718
  },
  {
    "_id": "Ti3dRmcnsGvqEb2ki",
    "lat": -36.8211175,
    "lng": 174.7250069
  },
  {
    "_id": "FqwHAXu6uGvq7gFfX",
    "lat": -43.5298694,
    "lng": 172.6225197
  },
  {
    "_id": "FcXdJDsaifbWqYeZa",
    "lat": -41.2788499,
    "lng": 174.7791569
  },
  {
    "_id": "E6wLzn7ws2B4DR5uC",
    "lat": 1.3142203,
    "lng": 103.8099293
  },
  {
    "_id": "ZuWboG5vPDrKDYHwc",
    "lat": 39.89721,
    "lng": 32.8632769
  },
  {
    "_id": "vGqjCQdCeaHzpBKqD",
    "lat": 25.2345391,
    "lng": 55.2938963
  },
  {
    "_id": "iGLqDZwtGPycHfgAf",
    "lat": 10.8106943,
    "lng": 106.7174933
  },
  {
    "_id": "FMNAWzkNzyNzytzh3",
    "lat": 42.7094896,
    "lng": 23.3670996
  },
  {
    "_id": "XoHoZzBnSJu6BxNes",
    "lat": 49.1945896,
    "lng": 16.6066598
  },
  {
    "_id": "a7gFfo95rYHfcjKwT",
    "lat": 55.6538445,
    "lng": 12.566032
  },
  {
    "_id": "Ei3MKRfdH4eXnPjnD",
    "lat": 55.6538445,
    "lng": 12.566032
  },
  {
    "_id": "jyamrDTKYokYtkoAj",
    "lat": 60.1693776,
    "lng": 24.9403506
  },
  {
    "_id": "h3SLQfvDsBwSjQK7t",
    "lat": 48.8236707,
    "lng": 2.3363838
  },
  {
    "_id": "i578yN2oziDkcgnkp",
    "lat": 44.8089756,
    "lng": -0.5898561
  },
  {
    "_id": "Q2diMGMYxrv7fA3fi",
    "lat": 43.5863774,
    "lng": 1.4468235
  },
  {
    "_id": "4mx9utNvcvvmWnWzK",
    "lat": 52.545187,
    "lng": 13.385562
  },
  {
    "_id": "pPhYytj5BzognTn79",
    "lat": 53.0734443,
    "lng": 8.8243865
  },
  {
    "_id": "4EBpKSZnwEmpdm7h9",
    "lat": 50.9334458,
    "lng": 6.8481128
  },
  {
    "_id": "6JSpaCFpz3W4Mfko2",
    "lat": 49.8707825,
    "lng": 8.6512084
  },
  {
    "_id": "9gKjefGAHZcCzieRW",
    "lat": 47.9894392,
    "lng": 7.839461999999999
  },
  {
    "_id": "qymNcigbQqkC5jGEb",
    "lat": 53.5606862,
    "lng": 9.9833765
  },
  {
    "_id": "36nnz55vYcdccopGa",
    "lat": 51.3362799,
    "lng": 12.4028547
  },
  {
    "_id": "auoeyCjkcGmhi8dkf",
    "lat": 49.4804532,
    "lng": 8.471360599999999
  },
  {
    "_id": "5Fmvu6hpRCfmb9yvW",
    "lat": 48.1490198,
    "lng": 11.5562246
  },
  {
    "_id": "EfPfgZe2PocqvXBLq",
    "lat": 37.9398398,
    "lng": 23.6923394
  },
  {
    "_id": "hbodWP3zp4quMo8eT",
    "lat": 47.4922565,
    "lng": 19.0631741
  },
  {
    "_id": "JqAFEvW33Fqk9JZii",
    "lat": 42.9512788,
    "lng": 12.7005802
  },
  {
    "_id": "ctykSscfNEioydydM",
    "lat": 45.470932,
    "lng": 9.2060356
  },
  {
    "_id": "dyviNnc4M3bxr3cvg",
    "lat": 43.7178148,
    "lng": 10.4031703
  },
  {
    "_id": "h9dJuND7NiPFbwKK9",
    "lat": 41.88578400000001,
    "lng": 12.5687
  },
  {
    "_id": "A2yrqbQ2hgQX4r9JQ",
    "lat": 46.06753399999999,
    "lng": 13.235647
  },
  {
    "_id": "ceuqCbjMxHgzRkrjd",
    "lat": 56.9417918,
    "lng": 24.1211974
  },
  {
    "_id": "tiCamcCgasPFSszu4",
    "lat": 54.68757309999999,
    "lng": 25.2805674
  },
  {
    "_id": "kGqRAiWtDfeGkrNyB",
    "lat": 52.3864241,
    "lng": 4.8839647
  },
  {
    "_id": "mbemRemwuuMAsCYmA",
    "lat": 59.9294393,
    "lng": 10.7143497
  },
  {
    "_id": "fXdbNHrRncg2r84uF",
    "lat": 38.7326073,
    "lng": -9.154358799999999
  },
  {
    "_id": "a7vdyJfATFR4XfT7K",
    "lat": 55.788363,
    "lng": 37.6787319
  },
  {
    "_id": "qxfYxHAN3GdBs8B8m",
    "lat": 44.8125987,
    "lng": 20.4755205
  },
  {
    "_id": "Aqf3kpFMw9CZKEae4",
    "lat": 46.0530857,
    "lng": 14.4996582
  },
  {
    "_id": "rTmq5dsp2ES55Aftu",
    "lat": 41.3885777,
    "lng": 2.1850886
  },
  {
    "_id": "kE2TwzB6cC8xgWLMg",
    "lat": 40.4187901,
    "lng": -3.6866418
  },
  {
    "_id": "THeTqwyTKKreKBEiu",
    "lat": 57.70529819999999,
    "lng": 11.9711591
  },
  {
    "_id": "dF3Mxtpz8D7vZNtvw",
    "lat": 59.3310944,
    "lng": 18.0595668
  },
  {
    "_id": "6gb9HkDiSwXfSaCqk",
    "lat": 46.9500259,
    "lng": 7.4386814
  },
  {
    "_id": "PKQCg2QJjXqBGxf3c",
    "lat": 46.2268462,
    "lng": 6.0804159
  },
  {
    "_id": "dXDCTpozyrmfHWLqk",
    "lat": 47.3545374,
    "lng": 8.5519549
  },
  {
    "_id": "8fbgAaHbFisFDFm6B",
    "lat": 51.4570984,
    "lng": -2.5908125
  },
  {
    "_id": "kgFQNDm7SwW5bct7j",
    "lat": 52.2040589,
    "lng": 0.118463
  },
  {
    "_id": "qH9qScj5SttZdcKDg",
    "lat": 51.4830073,
    "lng": -3.1748035
  },
  {
    "_id": "jQRp4ggbhuMbhDJuB",
    "lat": 55.9478129,
    "lng": -3.1815763
  },
  {
    "_id": "T99XpyuwaaNqPg3fB",
    "lat": 53.40192829999999,
    "lng": -2.9803989
  },
  {
    "_id": "4sgxDgBg6B3RrPogg",
    "lat": 51.5251929,
    "lng": -0.0713327
  },
  {
    "_id": "Fyr5BGq7kB3dknTYL",
    "lat": 53.4776933,
    "lng": -2.2526688
  },
  {
    "_id": "Mnu5aRkj2vbcAidT7",
    "lat": 54.9690679,
    "lng": -1.6172061
  },
  {
    "_id": "eEPPThTmoQhQmSeqY",
    "lat": 51.7494513,
    "lng": -1.2382764
  },
  {
    "_id": "T7DErsiNqopZFkWi5",
    "lat": 53.38005219999999,
    "lng": -1.4733416
  },
  {
    "_id": "gt58F2FCWeTFhrKjp",
    "lat": 51.0430983,
    "lng": -114.0799659
  },
  {
    "_id": "LyGyTA3NEjzo3AJ7W",
    "lat": 53.5415135,
    "lng": -113.490647
  },
  {
    "_id": "LvdJedGuTXRnnCZLf",
    "lat": 44.6509127,
    "lng": -63.5815233
  },
  {
    "_id": "MQFjkagkWbZG4qLTR",
    "lat": 43.4527631,
    "lng": -80.4863763
  },
  {
    "_id": "5pxmhfQ2qCSfxFsov",
    "lat": 43.54368789999999,
    "lng": -79.70048349999999
  },
  {
    "_id": "ngpZH9gA76CyHhrER",
    "lat": 45.5177162,
    "lng": -73.58697459999999
  },
  {
    "_id": "hjaWfJpbhyb8cyDZ6",
    "lat": 45.4012487,
    "lng": -75.72547949999999
  },
  {
    "_id": "92XuTcZPPeK2FtpPH",
    "lat": 45.3072983,
    "lng": -66.016363
  },
  {
    "_id": "iDdcxK8BLMrY7bQ36",
    "lat": 43.6598343,
    "lng": -79.3881786
  },
  {
    "_id": "acGsM6peFiYEFvdff",
    "lat": 19.4133877,
    "lng": -99.1719176
  },
  {
    "_id": "CyDMprs6XwkQeb3qf",
    "lat": 20.6352014,
    "lng": -87.06897099999999
  },
  {
    "_id": "b4Brc7RPBz2dKrqeE",
    "lat": 61.1844984,
    "lng": -149.9262106
  },
  {
    "_id": "Xq7TgQJahy6hJY48d",
    "lat": 42.2717803,
    "lng": -83.7305744
  },
  {
    "_id": "qcReFwm36ueYuShJe",
    "lat": 35.480104,
    "lng": -82.53918139999999
  },
  {
    "_id": "EEgyFex3bYbua7Bsn",
    "lat": 33.8021964,
    "lng": -84.4266667
  },
  {
    "_id": "Wsb3FAgwJeJjKS3ia",
    "lat": 30.3059651,
    "lng": -97.7376388
  },
  {
    "_id": "55fS4xcKCtve6ZAGQ",
    "lat": 39.2552611,
    "lng": -76.7154223
  },
  {
    "_id": "whs4dNKmpxg7vMccA",
    "lat": 48.7573173,
    "lng": -122.4904924
  },
  {
    "_id": "Fqshn6vr6AFBTxKDY",
    "lat": 37.8599417,
    "lng": -122.2595841
  },
  {
    "_id": "F8dt52bjrm8oHRxvT",
    "lat": 42.3706642,
    "lng": -71.1231275
  },
  {
    "_id": "oC4DJsGTcxMBRE8Ej",
    "lat": 40.0190763,
    "lng": -105.1404855
  },
  {
    "_id": "nkjHrKLdMgvtmM9DL",
    "lat": 44.4559498,
    "lng": -73.2262447
  },
  {
    "_id": "BrGmbH3McfBoXcfDC",
    "lat": 39.3999597,
    "lng": -107.2134251
  },
  {
    "_id": "6RaozuExMdJBbmhwb",
    "lat": 43.3823316,
    "lng": -72.60789650000001
  },
  {
    "_id": "aTZjzPuBorDsHh6Cw",
    "lat": 38.3516847,
    "lng": -81.6350894
  },
  {
    "_id": "2r7a5zuYggDLbAEaG",
    "lat": 35.2406127,
    "lng": -80.8131453
  },
  {
    "_id": "CGrtjD4K74njfx93u",
    "lat": 38.035277,
    "lng": -78.500725
  },
  {
    "_id": "f7RKAAcDgNNmoLw7j",
    "lat": 41.873835,
    "lng": -87.62252900000001
  },
  {
    "_id": "es7imJsasstguyp29",
    "lat": 39.1319106,
    "lng": -84.4626694
  },
  {
    "_id": "82qkAcALwxS7RtAWC",
    "lat": 41.4860542,
    "lng": -81.7045576
  },
  {
    "_id": "hezmhsbLN3BfjFw8H",
    "lat": 38.9859704,
    "lng": -76.9450882
  },
  {
    "_id": "QPjRFzWq8KJfLKyhh",
    "lat": 30.6229727,
    "lng": -96.3282983
  },
  {
    "_id": "KiumNi8opCqGHaxSK",
    "lat": 39.97195139999999,
    "lng": -82.9463167
  },
  {
    "_id": "qfNcTromGTcAQg4Df",
    "lat": 44.559656,
    "lng": -123.263016
  },
  {
    "_id": "fbLhYJxKxDhEqC6Yu",
    "lat": 32.9073768,
    "lng": -96.8032027
  },
  {
    "_id": "Rw8JxdNAKtnsDr4nT",
    "lat": 38.5421935,
    "lng": -121.7410058
  },
  {
    "_id": "KrTGdKv9LYLhMqACT",
    "lat": 39.752063,
    "lng": -105.048312
  },
  {
    "_id": "ii6o786sfLp7kvPhP",
    "lat": 35.9894268,
    "lng": -78.894975
  },
  {
    "_id": "EzQTT97KenkFkPZJa",
    "lat": 32.7788752,
    "lng": -115.5638572
  },
  {
    "_id": "xNjjhonBshXJEk6QP",
    "lat": 44.0536353,
    "lng": -123.1044572
  },
  {
    "_id": "aCqgnjNA2fJSsmsbm",
    "lat": 36.07344399999999,
    "lng": -94.16085220000001
  },
  {
    "_id": "6DR5bCivG4JmRZxvD",
    "lat": 26.1003738,
    "lng": -80.13756029999999
  },
  {
    "_id": "FBarjo2wnJxDjj89x",
    "lat": 39.1549391,
    "lng": -120.9904776
  },
  {
    "_id": "jNLNeoMF4xkgTruGC",
    "lat": 30.4133923,
    "lng": -87.2139444
  },
  {
    "_id": "notXg8sbX38cBdQtz",
    "lat": 40.2707075,
    "lng": -76.88753059999999
  },
  {
    "_id": "RytzZxwAMNFhEa9Pg",
    "lat": 41.7660919,
    "lng": -72.71002659999999
  },
  {
    "_id": "tsgZ6MwiaFBveewPu",
    "lat": 29.744523,
    "lng": -95.33945589999999
  },
  {
    "_id": "nqs5tPkzyK3cwjm8v",
    "lat": 34.7153078,
    "lng": -86.67279479999999
  },
  {
    "_id": "rQ9kNApLeaFmqdXiH",
    "lat": 42.2509017,
    "lng": -84.4218827
  },
  {
    "_id": "3rC8nyWBmjJg2dAtS",
    "lat": 42.6698913,
    "lng": -78.4145704
  },
  {
    "_id": "zYFRqLFcvp88ohMYu",
    "lat": 39.1085972,
    "lng": -94.582715
  },
  {
    "_id": "QvvYp7HKrYGCqDyQz",
    "lat": 43.8125715,
    "lng": -91.25425949999999
  },
  {
    "_id": "DBi9uXPnipzex5Wt4",
    "lat": 36.1468685,
    "lng": -115.3009448
  },
  {
    "_id": "brgys6w63Fn2rxrWg",
    "lat": 41.7418454,
    "lng": -111.8221997
  },
  {
    "_id": "AnjJzZ5ZWxsHWxCYa",
    "lat": 33.9963629,
    "lng": -118.4156507
  },
  {
    "_id": "tvRsR5jTtbAi7TYya",
    "lat": 33.5190924,
    "lng": -101.946802
  },
  {
    "_id": "QQkXsHoLF2n9NBzSb",
    "lat": 43.023602,
    "lng": -89.48453599999999
  },
  {
    "_id": "SomE2xtvaewnAqG53",
    "lat": 40.712063,
    "lng": -74.016188
  },
  {
    "_id": "JWhY5HFetFzuiRZi4",
    "lat": 40.6552005,
    "lng": -73.4751276
  },
  {
    "_id": "S4zTkEBBTNQEWyiLp",
    "lat": 35.152023,
    "lng": -90.01346840000001
  },
  {
    "_id": "Wy3oLa4krFrtCDq5u",
    "lat": 25.7953818,
    "lng": -80.1867092
  },
  {
    "_id": "g7rjJtMEDbpYkLvCE",
    "lat": 44.9343436,
    "lng": -93.23912639999999
  },
  {
    "_id": "hqJ6ZphFBmGGomFap",
    "lat": 29.9413428,
    "lng": -90.10239229999999
  },
  {
    "_id": "gECWBdvuv8uwovRi6",
    "lat": 33.6144695,
    "lng": -117.8591423
  },
  {
    "_id": "fMcxBfAimukmqpAzB",
    "lat": 42.3306961,
    "lng": -71.19443509999999
  },
  {
    "_id": "6cHzfy3TpSAxXTrwy",
    "lat": 36.8674841,
    "lng": -76.29861559999999
  },
  {
    "_id": "Zxd2Sa4HaeESZWHXD",
    "lat": 42.3181269,
    "lng": -72.6333128
  },
  {
    "_id": "n95A9tZDb7amQxy2Z",
    "lat": 39.9486559,
    "lng": -75.1730745
  },
  {
    "_id": "Q6DSBkmhJZbq7HijD",
    "lat": 33.4756895,
    "lng": -112.0903687
  },
  {
    "_id": "vPeAKEk7XtqF4FbKR",
    "lat": 40.4517396,
    "lng": -79.9194888
  },
  {
    "_id": "wxzKYnKMwekxxKoSW",
    "lat": 45.5341187,
    "lng": -122.6502648
  },
  {
    "_id": "4cgTSvHh7P4tN8Hbf",
    "lat": 40.3499808,
    "lng": -74.6615657
  },
  {
    "_id": "MgMHBBpQjLpvFx64f",
    "lat": 47.6610719,
    "lng": -122.0920527
  },
  {
    "_id": "DtreuTDZcDqYAs4pB",
    "lat": 37.5581958,
    "lng": -77.4612166
  },
  {
    "_id": "DtvBmtWcHGtjPbrHu",
    "lat": 43.1563944,
    "lng": -77.5990453
  },
  {
    "_id": "vdQ3YzFiqtLgjgoNJ",
    "lat": 38.5616673,
    "lng": -121.4825211
  },
  {
    "_id": "YTNbBxTHpLG5ME27x",
    "lat": 40.7467891,
    "lng": -111.8763126
  },
  {
    "_id": "uuY9MiMHLn23sBoRW",
    "lat": 29.4362652,
    "lng": -98.4808205
  },
  {
    "_id": "9MA8iXvL3RDeP7wko",
    "lat": 32.7392362,
    "lng": -117.133824
  },
  {
    "_id": "TCTYL3W3pgsrsjq3P",
    "lat": 37.7644832,
    "lng": -122.4378848
  },
  {
    "_id": "xCaRLB7cECvtKatfL",
    "lat": 47.6303606,
    "lng": -122.3172323
  },
  {
    "_id": "cesjnYvEYdtTyK7XL",
    "lat": 43.5323702,
    "lng": -96.7220767
  },
  {
    "_id": "ouEGPP5exKhWGKM4H",
    "lat": 41.6752496,
    "lng": -86.2501185
  },
  {
    "_id": "Lv6E4zdZGi5x3oKC4",
    "lat": 38.6049978,
    "lng": -90.2489106
  },
  {
    "_id": "W2WES4JGEpT8t9etL",
    "lat": 45.8454031,
    "lng": -91.53859849999999
  },
  {
    "_id": "8v8KcRGRBesXaXeox",
    "lat": 37.36883,
    "lng": -122.0363496
  },
  {
    "_id": "JuxkmLwNcDv5kzhTz",
    "lat": 36.40797990000001,
    "lng": -105.5711155
  },
  {
    "_id": "8LABLkzsqHdbfynRh",
    "lat": 41.6675635,
    "lng": -83.6729688
  },
  {
    "_id": "pBjLgfenoDoE46xq2",
    "lat": 32.2245583,
    "lng": -110.9652399
  },
  {
    "_id": "StBQkMYtQoGhQhake",
    "lat": 33.2104796,
    "lng": -87.5526261
  },
  {
    "_id": "s3FRraF568n8FuE7u",
    "lat": 40.113856,
    "lng": -88.22424199999999
  },
  {
    "_id": "ixLA7FCypwvrtCrGn",
    "lat": 38.9028167,
    "lng": -77.04586789999999
  },
  {
    "_id": "uqoM6n5nhy9yJpQK9",
    "lat": 40.4256187,
    "lng": -86.9251065
  },
  {
    "_id": "zSnzsZWYYGpdRySTu",
    "lat": 26.6988881,
    "lng": -80.0635902
  },
  {
    "_id": "YjczugErJ5zyK2dKD",
    "lat": 32.9930285,
    "lng": -97.1902291
  },
  {
    "_id": "qLZifrZWhGwStKnSd",
    "lat": -34.5963387,
    "lng": -58.4198371
  },
  {
    "_id": "c4vfYNusrtcS4CtF6",
    "lat": -22.9510351,
    "lng": -43.1842273
  },
  {
    "_id": "NuQHcXx27DSEdbBeq",
    "lat": -34.9146374,
    "lng": -54.86168199999999
  }
];
